export default __webpack_public_path__ + "static/media/social_facebook.df563a26.svg";